<div [formGroup]="formGroup">
  <ta-form-field label="{{ rootName }}">
    <div class="monospace">
      <ta-textarea formControlName="jsonText"></ta-textarea>
    </div>
  </ta-form-field>

  <div *ngIf="jsonIsValid; else invalidJson" class="color--success">
    <ta-icon icon="circle"></ta-icon>
    Valid JSON
  </div>

  <ng-template #invalidJson>
    <div class="color--danger">
      <ta-icon icon="circle"></ta-icon>
      Invalid JSON
    </div>
  </ng-template>
</div>
